/** @jsx jsx */
import ReactTooltip from 'react-tooltip'
import { Flex, Text, jsx } from 'theme-ui'
import { Info } from '../../icons/index'
import DropZone from '../common/form/FormInput/dropzone/DropZone'
import UploadTooltip from './UploadTooltip'

const UploadQuestion = ({ ...props }) => {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        mt: 5,
      }}
      {...props}
    >
      <Flex
        sx={{
          flexDirection: 'row',
        }}
      >
        <Text variant={'h5'} sx={{ mr: 3 }}>
          Submit file(s):
        </Text>
        <Flex data-tip data-for="upload-tooltip">
          <Info />
        </Flex>
        <ReactTooltip
          id="upload-tooltip"
          sx={{ maxWidth: 500, opacity: 1 }}
          place={'right'}
          backgroundColor={'white'}
          textColor={'black'}
          effect={'solid'}
        >
          <UploadTooltip />
        </ReactTooltip>
      </Flex>
      <DropZone sx={{ width: 500, mt: 3 }} />
    </Flex>
  )
}

export default UploadQuestion
